import $ from "jquery";

// BS5.3 scrollspy toggles `.active` on the matched <a> link itself; BS3 toggled it on the parent
// <li>. The sidebar highlight CSS keys on `#sections-nav li.active > a`, so after each activation
// mirror BS5's link-level active state back onto the parent <li> (clearing any stale ones). This
// restores the prod "you are here" red highlight, which went dead when bootstrap-sass (BS3) was
// removed (BS5 now sets `a.active`, which nothing was keyed on). BS5's EventHandler bridges
// `activate.bs.scrollspy` to jQuery when window.jQuery is present, so the jQuery `.on` handler fires.
//
// NOTE: prod also ran a `scrollItemIntoView` handler (scroll-into-view-if-needed on the active
// <li>) but it was INERT — it was handed a jQuery COLLECTION, which that library can't act on, so
// it never scrolled anything. The sidebar (`#sections-nav`) is not an independently-scrollable
// container (no overflow), so an *effective* scroll-into-view can only scroll the WINDOW, which
// fights the user's own scroll on every activation (page stutters / gets thrown back up). We match
// prod's effective behaviour and deliberately do NOT reinstate it.
const syncActiveLi = function () {
  const container = $("#sections-nav-container");
  container.find("li.active").removeClass("active");
  container.find("a.active").each((i, a) => $(a).closest("li").addClass("active"));
};

$(document).on("turbolinks:load", function () {
  // Bootstrap's own ScrollSpy silently retargets itself at `document.body` when the
  // configured target selector matches nothing (`config.target = getElement(config.target)
  // || document.body`, bootstrap/js/src/scrollspy.js). On any page without the sub-section
  // sidebar (e.g. /support-centre), that turns its "clear the active class" step into a
  // page-wide sweep that strips `.active` off the FIRST `[href].active` element it finds
  // anywhere on the page -- including unrelated nav-tabs strips -- within moments of load.
  // Only initialize scrollspy where its real target actually exists.
  if ($("#sections-nav-container").length === 0) {
    return;
  }

  const mainHeader = $("header.main-header");
  const body = $("body:not(.global_searches)");
  body.scrollspy({ target: "#sections-nav-container", offset: mainHeader.height() + 25 });
  body.on("activate.bs.scrollspy", syncActiveLi);
  syncActiveLi();
});
